import {
  GridComponent,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Inject,
  Resize,
  Edit,
  Sort,
  CommandColumn,
  ForeignKey,
  Filter,
  Toolbar,
  ExcelExport,
  PdfExport,
  getStateEventArgument,
  columnSelectionComplete,
} from "@syncfusion/ej2-react-grids";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { auth, cicassService } from "../../../_services";
import React from "react";
import { withTranslation } from "react-i18next";
import { Typography, Box} from "@mui/material";

const editSettings = {
  allowEditing: false,
  allowAdding: true,
  allowDeleting: true,
  newRowPosition: "Top",
  showDeleteConfirmDialog: true,
};
const filterSettings = { type: "CheckBox" }; // Menu, Excel
const commands = [
  {
    type: "Delete",
    buttonOption: { iconCss: "e-icons e-delete", cssClass: "e-flat" },
  },
  {
    type: "Save",
    buttonOption: { iconCss: "e-icons e-update", cssClass: "e-flat" },
  },
  {
    type: "Cancel",
    buttonOption: { iconCss: "e-icons e-cancel-icon", cssClass: "e-flat" },
  },
  {
    type: "Role",
    buttonOption: { iconCss: "e-icons e-MT_List", cssClass: "e-flat" },
  },
];
const toolbarOptions = [
  "Search",
  "Add",
  "ExcelExport",
  "Print",
  {
    text: "Refresh",
    tooltipText: "Refresh",
    prefixIcon: "e-MT_reload",
    id: "forceRefresh",
  },
  {
    text: "Back",
    tooltipText: "Back",
    prefixIcon: "e-MT_Backward",
    id: "backToUserList",
  },
];
const apiUrl = "ana_calendar_shift";
const apiUrlShiftCombo = "ana_shift";

class AnaCalendarShift extends React.Component {
  _isMounted = false;
  grid = null;

  constructor(props) {
    super(props);
    this.position = { X: "Right", Y: "Bottom" };
    this.state = {
      myData: [],
      visibleOnGrid: false,
      didMountCompleted: false,
      isCicass: false,
      isAdmin: false,
      shiftData: [],
      toastInfo: {
        title: "",
        content: "Succesfully",
        cssClass: "e-toast-success",
        icon: "e-success toast-icons",
      },
      anaCalendarIdSelected: 0,
    };
    this.validationRules = { required: true };
    this.actionComplete = this.actionComplete.bind(this);
    this.actionBegin = this.actionBegin.bind(this);
    this.refreshGrid = this.refreshGrid.bind(this);
  }

  async componentDidMount() {
    this._isMounted = true;
    const myrole = auth.getUserRole();
    const anaCalendarIdSelected = this.props.match.params.id;
    let { data: myData } = await cicassService.getAll(
      apiUrl + "/ana/" + anaCalendarIdSelected
    );
    let { data: shiftData } = await cicassService.getAll(apiUrlShiftCombo);

    if (this._isMounted) {
      this.setState({
        didMountCompleted: true,
        myData,
        shiftData,
        anaCalendarIdSelected,
        isCicass: myrole == "SuperUser" ? true : false,
        isAdmin: myrole == "Admin" || myrole == "SuperUser" ? true : false,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toolbarClick(args) {
    switch (args.item.properties.id) {
      case "gridcomp_excelexport":
        this.gridInstance.excelExport();
        break;
    }
    if (args.item.id === "forceRefresh") {
      this.refreshGrid();
    }
    if (args.item.id === "backToUserList") {
      //window.location.href = "/app/anacalendar";
      this.props.history.push(`/app/anacalendar/`);
    }
  }

  refreshGrid() {
    const { anaCalendarIdSelected } = this.state;
    cicassService
      .getAll(apiUrl + "/ana/" + anaCalendarIdSelected)
      .then((response) => {
        this.setState({ myData: response.data });
      });
  }

  actionBegin(state) {
    const { anaCalendarIdSelected } = this.state;
    if (state.requestType == "beginEdit" || state.requestType == "add") {
      if (state.requestType == "add") {
        state.data.id = -1;
        state.data.anaCalendarId = anaCalendarIdSelected;
      }
      this.setState({ visibleOnGrid: true });
    }
  }

  actionComplete(state) {
    /*if (state.requestType === "add" || state.requestType === "beginEdit") {
      state.dialog.enableResize = true;
      //state.dialog.element.style.maxHeight = 900;
      state.dialog.width = 600;
      state.dialog.height = 600;
    }*/
    const { t } = this.props;
    if (state.action === "add") {
      state.data.id = -1;
      cicassService
        .saveOp(apiUrl, state.data)
        .then(() => {
          this.setToastInfo("Success", t("addToastOK"));
          this.refreshGrid();
        })
        .catch((err) => {
          this.setToastInfo("Error", "I: " + err.message);
          this.refreshGrid();
        });
    }
    if (state.requestType === "delete") {
      cicassService
        .deleteOp(apiUrl, state.data[0].id)
        .then(() => {
          this.setToastInfo("Warning", t("deleteToastOK"));
          this.refreshGrid();
        })
        .catch((err) => {
          this.setToastInfo("Error", "D:" + err.message);
          this.refreshGrid();
        });
    }

    this.setState({ visibleOnGrid: false });
  }

  setToastInfo(title, errorMsg) {
    let { toastInfo } = this.state;
    switch (title) {
      case "Warning":
        toastInfo.title = "Warning";
        toastInfo.content = errorMsg;
        toastInfo.cssClass = "e-toast-warning";
        toastInfo.icon = "e-warning toast-icons";
        break;
      case "Success":
        toastInfo.title = "Success";
        toastInfo.content = errorMsg;
        toastInfo.cssClass = "e-toast-success";
        toastInfo.icon = "e-success toast-icons";
        break;
      case "Error":
        toastInfo.title = "Error";
        toastInfo.content = errorMsg;
        toastInfo.cssClass = "e-toast-danger";
        toastInfo.icon = "e-error toast-icons";
        break;
      case "Information":
        toastInfo.title = "Information";
        toastInfo.content = errorMsg;
        toastInfo.cssClass = "e-toast-info";
        toastInfo.icon = "e-info toast-icons";
        break;
    }
    this.setState({ toastInfo });
    this.toastObj.show();
    return;
  }

  async commandClick(args) {
    if (args.commandColumn) {
      if (args.commandColumn.type === "Role") {
        let shiftSelected = this.state.shiftData.filter(
          (x) => x.id == args.rowData.anaShiftId
        );
        this.props.history.push(
          `/app/anacalendarshiftrole/` + args.rowData.id,
          this.props.location.state + " - " + shiftSelected[0].name
        );
      }
    }
  }

  render() {
    const {
      myData,
      didMountCompleted,
      shiftData,
      isCicass,
      toastInfo,
      isAdmin,
    } = this.state;
    const { t } = this.props;
    return (
      <>
        <div style={{ margin: "1%", marginTop: "1%" }}>
          <Typography variant="h6" component="h2">
            {t("titleAnaCalendarShiftJs")} - {this.props.location.state}
          </Typography>
        </div>
        <Box sx={{ p: 2, flex: '1 1 auto' }}>
          {didMountCompleted && (
            <GridComponent
              id="gridcomp"
              ref={(grid) => (this.gridInstance = grid)}
              dataSource={myData}
              toolbar={toolbarOptions}
              editSettings={editSettings}
              allowResizing={true}
              allowFiltering={true}
              filterSettings={filterSettings}
              allowPaging={true}
              pageSettings={{ pageSize: 10, pageCount: 5 }}
              allowExcelExport={true}
              actionComplete={this.actionComplete}
              actionBegin={this.actionBegin}
              toolbarClick={this.toolbarClick.bind(this)}
              locale="it"
              allowSorting={true}
              commandClick={this.commandClick.bind(this)}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="id"
                  headerText={t("id")}
                  textAlign="Right"
                  isPrimaryKey={true}
                  defaultValue="-1"
                  allowEditing={false}
                  visible={isCicass}
                />
                <ColumnDirective
                  field="anaShiftId"
                  headerText={t("anaShiftId")}
                  foreignKeyValue="name"
                  foreignKeyField="id"
                  dataSource={shiftData}
                  width="150"
                  validationRules={this.validationRules}
                />
                <ColumnDirective
                  field="anaCalendarId"
                  headerText={t("anaCalendarId")}
                  visible={isCicass}
                  allowEditing={false}
                  validationRules={this.validationRules}
                />
                <ColumnDirective
                  field="createdAt"
                  headerText={t("createdAt")}
                  type="date"
                  format={"dd/MM/yyyy HH:mm:ss"}
                  visible={isCicass}
                  allowEditing={false}
                />
                <ColumnDirective
                  field="updatedAt"
                  headerText={t("updatedAt")}
                  type="date"
                  format={"dd/MM/yyyy HH:mm:ss"}
                  visible={isCicass}
                  allowEditing={false}
                />
                <ColumnDirective
                  headerText={t("operationOnGrid")}
                  width="160"
                  commands={commands}
                ></ColumnDirective>
              </ColumnsDirective>
              <Inject
                services={[
                  Resize,
                  Filter,
                  Page,
                  Toolbar,
                  Edit,
                  ForeignKey,
                  CommandColumn,
                  ExcelExport,
                  Sort,
                ]}
              />
            </GridComponent>
          )}
          <ToastComponent
            ref={(toast) => {
              this.toastObj = toast;
            }}
            id="toast_default"
            position={this.position}
            title={toastInfo.title}
            content={toastInfo.content}
            cssClass={toastInfo.cssClass}
            icon={toastInfo.icon}
          ></ToastComponent>
        </Box>
      </>
    );
  }
}
export default withTranslation()(AnaCalendarShift);
